/** Map establishment API row to profile form state (hospital portal). */
export const mapEstablishmentToProfileForm = (est) => {
  if (!est) return {};

  const asStr = (v) => (v != null && v !== "" ? String(v) : "");

  const phoneNumbers = Array.isArray(est.phone_numbers)
    ? est.phone_numbers.filter(Boolean)
    : [est.phone_number_1, est.phone_number_2].filter(Boolean);

  const categoryLabel = est.category
    || est.establishment_category
    || est.category_name
    || "";

  return {
    establishment_id: est.establishment_id,
    category: categoryLabel,
    establishment_year: asStr(est.establishment_year),
    establishment_name: est.establishment_name || "",
    legal_entity_name: est.legal_entity_name || "",
    payout_percentage: est.payout_percentage ?? "",
    engagement_letter_path: est.engagement_letter_path || "",
    parent_establishment_id: asStr(est.parent_establishment_id),
    establishment_type_id: asStr(est.establishment_type_id),
    establishment_sub_type_id: asStr(est.establishment_sub_type_id),
    parent_establishment_display: est.parent_establishment_name || "None (Top-level)",
    establishment_type_display: est.establishment_type || "",
    establishment_sub_type_display: est.establishment_sub_type || "",
    country_name: est.country_name || "",
    location_name: est.location_name || "",
    state_name: est.state_name || "",
    city_name: est.city_name || "",
    registration_year: asStr(est.registration_year),
    registration_body: est.registration_body || "",
    accreditation_ids: est.accreditation_ids || "",
    country_id: est.country_id ?? "",
    location_id: est.location_id ?? "",
    country_code: est.country_code || "",
    phone_numbers: phoneNumbers.length ? phoneNumbers : [""],
    phone_number_1: est.phone_number_1 || phoneNumbers[0] || "",
    phone_number_2: est.phone_number_2 || phoneNumbers[1] || "",
    address: est.address || "",
    address_line_2: est.address_line_2 || "",
    state_id: est.state_id ?? "",
    city_id: est.city_id ?? "",
    longitude: est.longitude ?? "",
    latitude: est.latitude ?? "",
    email_address: est.email_address || "",
    website_address: est.website_address || "",
    short_profile: est.short_profile || "",
    long_profile: est.long_profile || "",
    logo_path: est.logo_path || "",
    profile_pdf_path: est.profile_pdf_path || "",
    virtual_tour_url: est.virtual_tour_url || "",
    department_ids: est.department_ids || "",
    specialization_type_ids: est.specialization_type_ids || "",
    total_beds: est.total_beds ?? "",
    total_ots: est.total_ots ?? "",
    total_doctors: est.total_doctors ?? "",
    total_critical_care_beds: est.total_critical_care_beds ?? "",
    emergency_dept_available: est.emergency_dept_available,
    blood_bank_available: est.blood_bank_available ?? est.ambulance_available,
    nicu_available: est.nicu_available,
    picu_available: est.picu_available,
    facebook_page: est.facebook_page || "",
    youtube_channel: est.youtube_channel || "",
    instagram: est.instagram || "",
    linkedin: est.linkedin || "",
    x_profile: est.x_profile || "",
    telegram_channel: est.telegram_channel || "",
  };
};

/** Merge saved establishment with in-progress form edits (form overrides saved). */
export const mergeProfileFormData = (savedProfile, formData = {}) => {
  const base = mapEstablishmentToProfileForm(savedProfile);
  if (!savedProfile?.establishment_id) return { ...formData };
  return {
    ...base,
    ...formData,
    establishment_id: savedProfile.establishment_id,
  };
};

const PROFILE_DETAIL_FIELDS = [
  "registration_year", "registration_body", "email_address", "website_address",
  "address", "address_line_2", "short_profile", "long_profile",
  "total_beds", "total_doctors", "facebook_page", "youtube_channel",
];

export const hasEstablishmentProfileData = (est) => {
  if (!est) return false;
  return PROFILE_DETAIL_FIELDS.some((key) => {
    const v = est[key];
    return v != null && v !== "" && v !== 0;
  }) || (Array.isArray(est.phone_numbers) && est.phone_numbers.some(Boolean));
};
